import eurekaMgrs from '@eureka/ui-managers';

const { getCsrfToken } = eurekaMgrs.ConfigManager;

export default class HeartBeatWebSocket {
  constructor(url, messageHandler) {
    this._url = url;
    this._messageHandler = messageHandler;
    this._ws = null;
    this._onWebSocketOpen = this._onWebSocketOpen.bind(this);
    this._onWebSocketClose = this._onWebSocketClose.bind(this);
    this._onWebSocketMessage = this._onWebSocketMessage.bind(this);
    this._startHeartBeat = this._startHeartBeat.bind(this);
    this._isOpen = this._isOpen.bind(this);
    this._maxReconnect = 30;
  }

  start() {
    if (!this._ws) {
      this.forceInitWebSocket();
    }
    return this;
  }

  forceInitWebSocket() {
    console.log(`[${new Date().toISOString()}] Force init Websocket connection`);
    if (this._ws) {
      this.close();
      this._ws.onopen = null;
      this._ws.onclose = null;
      this._ws.onmessage = null;
      this._ws.onerror = null;
    }
    this._ws = new WebSocket(this._url, [getCsrfToken()]);
    this._ws.onopen = this._onWebSocketOpen;
    this._ws.onclose = this._onWebSocketClose;
    this._ws.onmessage = this._onWebSocketMessage;
    this._ws.onerror = this._onWebSocketError;
  }

  _isOpen(ws) {
    return ws.readyState === ws.OPEN;
  }

  _onWebSocketOpen() {
    console.log(`Web Socket Connection to ${this._url} started.`, this._ws.readyState);
    if (this._isOpen(this._ws)) {
      this._interval = setInterval(this._startHeartBeat, 10000);
    }
  }

  _onWebSocketClose(evt) {
    console.log(`Web Socket Connection to ${this._url} closed.`, evt);
    if (this._maxReconnect <= 0) {
      console.log(
        'Stop reconnecting because the maximum number of reconnections has been exceeded',
        this._maxReconnect,
      );
      return;
    }
    this._maxReconnect--;
    this.forceInitWebSocket && this.forceInitWebSocket();
    console.log(`[${new Date().toISOString()}] Web Socket reconnected because of onclose`);
  }

  _onWebSocketError(error) {
    console.log(error);
    if (this._maxReconnect <= 0) {
      console.log(
        'Stop reconnecting because the maximum number of reconnections has been exceeded',
        this._maxReconnect,
      );
      return;
    }
    this._maxReconnect--;
    this.forceInitWebSocket && this.forceInitWebSocket();
    console.log(`[${new Date().toISOString()}] Web Socket reconnected because of onerror`);
  }

  _onWebSocketMessage(evt) {
    const msg = evt.data;
    if (msg.startsWith('-') && msg.endsWith('-')) {
      // We don't process heartbeat echo message
      return;
    }
    let dataJson = null;
    try {
      dataJson = JSON.parse(evt.data);
      this._messageHandler && this._messageHandler(dataJson);
      // eslint-disable-next-line
    } catch (e) {}
  }

  _startHeartBeat() {
    if (!this._isOpen(this._ws)) {
      console.log(`[${new Date().toISOString()}] Websocket connection is closed`);
      this.forceInitWebSocket();
    } else {
      try {
        this._ws.send(`-${Math.random()}-`);
      } catch (err) {
        console.error(
          `[${new Date().toISOString()}] Websocket send data, error: ${err.toString()}`,
        );
      }
    }
  }

  close() {
    clearInterval(this._interval);
    this._ws && this._ws.close();
  }
}
